import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'brl',
  standalone: false,
})
export class BrlPipe implements PipeTransform {
  transform(value: number): string {
    if (this.isInvalidValue(value)) {
      return '';
    }

    return this.format(value);
  }

  format(value) {
    const currencyPipe: CurrencyPipe = new CurrencyPipe('pt-BR');
    const newValue: string = currencyPipe.transform(value, 'BRL', true);
    return newValue;
  }

  isInvalidValue = (value) => value === undefined || value === null;
}
